// extracted by mini-css-extract-plugin
module.exports = {"dayOfWeek":"DayOfWeek-dayOfWeek-1iw4D","isSingleDay":"DayOfWeek-isSingleDay-1u6SC","isToday":"DayOfWeek-isToday-SozUU"};